<template>
  <v-container>
    <v-tab-item class="pb-0" eager>
      <first-tab @stepReleased="$emit('step-observer', { step: 0, complete: $event })" />
    </v-tab-item>
    <v-tab-item class="pb-0" eager>
      <second-tab @stepReleased="$emit('step-observer', { step: 1, complete: $event })" />
    </v-tab-item>
  </v-container>
</template>

<script>
  export default {
    components: {
      FirstTab: () => import('@/components/perdasAic/tabs/FirstTab.vue'),
      SecondTab: () => import('@/components/perdasAic/tabs/SecondTab.vue')
    },

    emits: ['step-observer'],

    methods: {
      exportData() {
        const vuexData = this.$store.state.perdasAic;

        return {
          id: this.$route.params.id ? this.$route.params.id : null,
          titulo: vuexData.titulo,
          obras: vuexData.obras,
          centros_custo: vuexData.centrosCusto,
          tipos: vuexData.tipos,
          data_lancamento_inicio: vuexData.dataLancamentoInicio,
          data_lancamento_fim: vuexData.dataLancamentoFim,
          percentuais: JSON.stringify(vuexData.percentuais)
        };
      }
    }
  };
</script>
